export const iconFontAwesomeGamingSquareSteam = (
	<i className="fa-solid fa-square-steam"></i>
);
